import { useTranslation } from "react-i18next";

interface ExternalProjectsReportsProps {}

const ExternalProjectsReports = ({}: ExternalProjectsReportsProps) => {
  const { t, i18n } = useTranslation();
  return (
    <section className="flex flex-col gap-8">
      {/* search bar section  */}
      <div className="p-[20px] w-full  bg-white shadow-shadow_profile rounded-[20px] ">
        <form className="flex flex-col lg:flex-row lg:items-end gap-5">
          {/* Report # */}
          <div className="w-full lg:w-[200px] flex flex-col gap-1">
            <p className="text-[14px] text-[#444444] font-[500]">Report #</p>
            <input
              type="text"
              className="w-full h-[32px] border-[#D9D9D9] border-[2px] focus:outline-none rounded-[12px]"
            />
          </div>

          {/* button submit */}
          <div>
            <button
              type="submit"
              className={` h-[32px] bg-first_color text-white text-[13px] lg:text-[16px] ${
                i18n.language === "en" ? "font-Poppins " : "font-Almarai "
              } font-[600] rounded-[10px] hover:bg-[#614629] duration-300 px-[30px] `}
            >
              Search
            </button>
          </div>
        </form>
      </div>

      {/* the table section  */}
      <div className="overflow-auto scroll max-h-[600px]">
        <table className="w-full min-w-[1100px]">
          <thead className="sticky top-0 bg-white whitespace-nowrap">
            <tr>
              <th className="px-4 py-4 text-[#808184] text-[14px]">Report #</th>
              <th className="px-4 py-4 text-[#808184] text-[14px]">Date</th>

              <th className="px-4 py-4 text-[#808184] text-[14px]">
                Project #
              </th>
              <th className="px-4 py-4 text-[#808184] text-[14px]">
                Project Name
              </th>
              <th className="px-4 py-4 text-[#808184] text-[14px]">Country</th>
              <th className="px-4 py-4 text-[#808184] text-[14px]">Paid</th>
              <th className="px-4 py-4 text-[#808184] text-[14px]">Status</th>
            </tr>
          </thead>

          <tbody className="p-[20px] bg-[#eaebea]">
            <tr>
              <td className="px-4 py-4 text-center text-[14px]">R-254512</td>
              <td className="px-4 py-4 text-center text-[14px]">15/5/2024</td>
              <td className="px-4 py-4 text-center text-[14px]">EP-1248785</td>
              <td className="px-4 py-4 text-center text-[14px]">
                Public Charity
              </td>
              <td className="px-4 py-4 text-center text-[14px]">India</td>
              <td className="px-4 py-4 text-center text-[14px]">5000 AED</td>

              <td className="px-4 py-4 text-center text-[14px]  text-green-500 font-[600]">
                Approved
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default ExternalProjectsReports;
